import { render } from "./shareGambit.vue?vue&type=template&id=8af3e816&scoped=true"
import script from "./shareGambit.vue?vue&type=script&lang=js"
export * from "./shareGambit.vue?vue&type=script&lang=js"

import "./shareGambit.vue?vue&type=style&index=0&id=8af3e816&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8af3e816"]])

export default __exports__